import { Component, EventEmitter, Optional } from "@angular/core";
import {
  FormBuilder,
  Validators,
  ControlContainer,
  FormGroup,
} from "@angular/forms";
import { Router } from "@angular/router";
import {
  RloApplicationFilterFormHelper,
  RloApplicationFilterFormState,
} from "./rloapplication-filter-form.helper";
import { BaseFpxFormComponent, ValidatorService } from "@fpx/core";
import { RloapplicationService } from "../rloapplication-service/rloapplication.service";

@Component({
  selector: "app-rloapplication-filter-form",
  templateUrl: "./rloapplication-filter-form.component.html",
  styleUrls: ["./rloapplication-filter-form.component.scss"],
  providers: [RloApplicationFilterFormHelper],
})
export class RloApplicationFilterFormComponent extends BaseFpxFormComponent<
RloApplicationFilterFormHelper,
  RloApplicationFilterFormState
> {
  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private router: Router,
    public rloapplicationFilterFormHelper: RloApplicationFilterFormHelper,
    public rloapplicationService:RloapplicationService,
    private validatorService: ValidatorService
  ) {
    super(
      formBuilder,
      router,
      controlContainer,
      rloapplicationFilterFormHelper
    );
  }
  protected override doPreInit(): void {
    this.addFormControl("applicantName", "", [], [], "blur", 1, false, 0);
    this.addFormControl("arn", "", [], [], "blur", 1, false, 0);
    this.addFormControl("type", "", [], [], "blur", 1, false, 0);
    this.addFormControl("stage", "", [], [], "blur", 1, false, 0);
    this.addFormControl("period", "", [], [], "blur", 1, false, 0);
    this.addFormControl("tat", "", [], [], "blur", 1, false, 0);


  }

  protected override doPostInit(): void {}
}
